import {
  IsEmail,
  IsNotEmpty,
  IsOptional,
  IsArray,
  ValidateNested,
  ValidateIf,
  IsDate,
  IsBoolean,
} from "class-validator";
import { Type } from "class-transformer";

import { JuniorNumberDto } from "../user/junior-number.dto";

// ------------
export class OwnerRegistrationDto {
  //
  @IsNotEmpty()
  @IsEmail(undefined, { message: "Invalid email" })
  email: string;

  @IsOptional()
  parent_email?: string;

  @IsNotEmpty({ message: "Password cannot be empty" })
  password: string;

  @IsNotEmpty({ message: "First Name cannot be empty" })
  first_name: string;

  @IsNotEmpty({ message: "Last Name cannot be empty" })
  last_name: string;

  @IsOptional()
  display_name?: string;

  @IsOptional()
  phone?: string;

  //Junior support
  @IsOptional()
  @IsBoolean()
  is_junior?: boolean;

  @IsOptional()
  parent_name?: string;

  @ValidateIf((o) => o.is_junior === true)
  @IsNotEmpty({ message: "Date of birth is required for junior accounts" })
  @IsDate({ message: "Invalid date of birth" })
  @Type(() => Date)
  junior_dob?: Date;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => JuniorNumberDto)
  junior_numbers?: JuniorNumberDto[];
}
